const urlBase = '#{AFFIXE2_API_BASE_URL}#/api/';
const urlDataplateforme = '#{AFFIXE2_DATAPLATFORME}#';
const urlBaseApi = '#{AFFIXE2_API_PORTAIL_CLIENT_BASE_URL}#/';
const urlBaseAffixe2 = '#{AFFIXE2_API_BASE_URL_FODECT}#/';

export default {
  URL_SERVEUR: urlBase,
  BASE_URL: urlBase + 'services/',
  BASE_URL_DATAPLATEFORME: urlDataplateforme,
  BASE_URL_API: urlBaseApi,
  BASE_URL_AFFIXE2: urlBaseAffixe2,
};
